import { isNilOrEmpty } from '@lucidlink/tscore';
import { HTTPScheme } from '#common/types';
import { DEFAULT_S3_REGION } from './region';
import { createRetryStrategy } from './retry';
export const createS3ClientConfig = (params) => {
    const s3Config = {
        region: isNilOrEmpty(params.region) ? DEFAULT_S3_REGION : params.region,
        credentials: params.credentialsProvider.getCredentials(),
        tls: params.httpScheme === HTTPScheme.HTTPS,
        forcePathStyle: !params.useVirtualAddressing,
        retryStrategy: createRetryStrategy(params.retryStrategy, params.retryOptions),
        requestChecksumCalculation: 'WHEN_REQUIRED',
        responseChecksumValidation: 'WHEN_REQUIRED',
    };
    if (!isNilOrEmpty(params.endpointOverride)) {
        const scheme = params.httpScheme == HTTPScheme.HTTPS ? 'https' : 'http';
        s3Config.endpoint = `${scheme}://${params.endpointOverride}`;
    }
    return s3Config;
};
